import { MdOutlineCalendarMonth } from 'react-icons/md';
import { BsReverseListColumnsReverse } from 'react-icons/bs';
import { RenderTiles } from '../../components/common';
import ChildHeader from '../../components/ui/ChildHeader';
import { TbRulerMeasure } from 'react-icons/tb';

const tiles = [
  {
    sNo: 1,
    link: '/common/msaplanlist',
    isLink: true,
    icon: <MdOutlineCalendarMonth size="5rem" color="#343a40" />,
    p: 'MSA',
    span: 'PLAN',
    isIcon: true,
  },

  {
    sNo: 2,
    link: '/common/MsaChecklistList',
    isLink: true,
    icon: <BsReverseListColumnsReverse size="5rem" color="#087f5b" />,
    p: 'MSA',
    span: 'STATUS',
    isIcon: true,
  },
  {
    sNo: 3,
    link: '/common/MSAList',
    isLink: true,
    icon: <TbRulerMeasure size="5rem" color="#343a40" />,
    p: 'GENERATE MSA',
    span: 'REPORT',
    isIcon: true,
  },
];

const Tiles = () => {
  return (
    <>
      <ChildHeader text="MSA" />
      <RenderTiles
        tilesObj={tiles}
        height="100vh"
        justify="start"
        columns="0"
      />
    </>
  );
};

export default Tiles;
